import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { DefaultHeaderComponent } from './components/default-header/default-header.component';
import { PatientDetailComponent } from './pages/patient-detail/patient-detail.component';
import { AccountComponent } from './pages/account/account.component';
import { AddPatientComponent } from './pages/add-patient/add-patient.component';
import { LoginComponent } from './pages/login/login.component';
import { RegistrationComponent } from './pages/registration/registration.component';
import { PatientListComponent } from './pages/patient-list/patient-list.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { EditProfileComponent } from './pages/edit-profile/edit-profile.component';
import { ChatListComponent } from './pages/chat-list/chat-list.component';
import { ChatComponent } from './pages/chat/chat.component';
import { EditTreatmentComponent } from './pages/edit-treatment/edit-treatment.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PolicyComponent } from './pages/policy/policy.component';
import { ForgotPwComponent } from './pages/forgot-pw/forgot-pw.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConvertDatePipe } from './pipe/convert-date.pipe';
import { AngularFireModule } from '@angular/fire'; // �ǉ�
import { AngularFirestoreModule } from '@angular/fire/firestore'; // �ǉ�
import { AngularFireAuthModule } from '@angular/fire/auth'; // �ǉ�
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';

import { environment } from 'src/environments/environment';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { AccountTwoComponent } from './pages/account-two/account-two.component';
import { AccountThreeComponent } from './pages/account-three/account-three.component';
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgxYubinBangoModule } from 'ngx-yubinbango';
import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { FilterParentPipe } from './pipe/filter-parent.pipe';
import { FilterChatPipe } from './pipe/filter-chat.pipe';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { OrderByPipe } from './pipe/order-by.pipe';
import { SortByNamePipe } from './pipe/sort-by-name.pipe';
import { IonicStorageModule } from '@ionic/storage-angular';


FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin
]);

@NgModule({
  declarations: [
    AppComponent,
    DefaultHeaderComponent,
    PatientDetailComponent,
    AccountComponent,
    AddPatientComponent,
    LoginComponent,
    RegistrationComponent,
    PatientListComponent,
    UserProfileComponent,
    EditProfileComponent,
    ChatListComponent,
    ChatComponent,
    EditTreatmentComponent,
    TermsComponent,
    PolicyComponent,
    ForgotPwComponent,
    ConvertDatePipe,
    PageNotFoundComponent,
    AccountTwoComponent,
    AccountThreeComponent,
    FilterChatPipe,
    OrderByPipe,
    FilterParentPipe,
    SortByNamePipe
  ],
  entryComponents: [],
  imports: [BrowserModule, BrowserAnimationsModule, IonicModule.forRoot(), AppRoutingModule,
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase), // �ǉ�,
    AngularFirestoreModule,  // �ǉ�
    AngularFireAuthModule,  // �ǉ�
    FormsModule,
    ReactiveFormsModule,
    NgxYubinBangoModule,

    FullCalendarModule],
  providers: [
    FirebaseX,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    SplashScreen,
    StatusBar,
    Badge,
    NgxImageCompressService],
  bootstrap: [AppComponent],
})
export class AppModule { }